import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';

import Typography from '../definitions/Typography';
import FilterPropType from '../definitions/FilterPropType';
import InputSelector from '../components/InputSelector';
import Select from './Select';


function FilterGroup({ filters, onChange, isDisabled, className, ...otherProps }) {
    // Deprecated - please use the "modern" approach.
    function handleOnChange(value, index) {
        const data = filters.map((filter, i) => ({
            name: filter.field.name,
            value: i == index ? value : filter.field.typedValue,
        }));

        onChange(data);
    }

    return (
        <div
            className={classNames('rh-px-1_5', className)}
            {...otherProps}
        >
            <div className={Typography.CLASSES.TEXT_L}>
                <For
                    each="filter"
                    of={filters}
                    index="index"
                >
                    {/* Fragment needed to supply a key to each filter.
                        Specifically the inline native Select will have strange behaviour if
                        this isn’t set, but it’s generally a best practice to include regardless. */}
                    <Fragment key={filter.field?.name ?? filter.name}>
                        <If condition={filter.leftHandText}>
                            <span>
                                {filter.leftHandText}
                            </span>
                            {' '}
                        </If>
                        <Choose>
                            <When condition={filter.field}>
                                <InputSelector
                                    field={filter.field}
                                    onChange={value => handleOnChange(value, index)}
                                    isInline={true}
                                    type="dropdown"
                                    optionsSort={filter.optionsSort}
                                />
                            </When>
                            <Otherwise>
                                <Select
                                    id={filter.name}
                                    name={filter.name}
                                    options={filter.options}
                                    value={filter.value}
                                    onChange={value => onChange({
                                        ...filters.reduce(
                                            (result, filter) => {
                                                result[filter.name] = filter.value;
                                                return result;
                                            },
                                            {},
                                        ),
                                        ...{ [filter.name]: value },
                                    })}
                                    isInline={true}
                                    isDisabled={isDisabled}
                                />
                            </Otherwise>
                        </Choose>
                        {' '}
                        <If condition={filter.rightHandText}>
                            <span>
                                {filter.rightHandText}
                            </span>
                            {' '}
                        </If>
                    </Fragment>
                </For>
            </div>
        </div>
    );
}

FilterGroup.propTypes = {
    onChange: PropTypes.func.isRequired,
    filters: PropTypes.oneOfType([
        PropTypes.object, // mobx observable array
        PropTypes.arrayOf(FilterPropType),
    ]).isRequired,
    isDisabled: PropTypes.bool,
    className: PropTypes.string,
};

FilterGroup.defaultProps = {
    isDisabled: false,
    className: undefined,
};


export default observer(FilterGroup);
